var BaseScore;
(function (BaseScore) {
    BaseScore[BaseScore["ExactMatch"] = 1] = "ExactMatch";
    BaseScore[BaseScore["StartsWith"] = 2] = "StartsWith";
    BaseScore[BaseScore["Includes"] = 3] = "Includes";
})(BaseScore || (BaseScore = {}));
const calcScore = (base, index) => {
    return base - (1 / Math.pow(2, index));
};
export const AddOn_SearchTerms = {
    key: 'searchTerms',
    methodName: 'getSearchTerms',
    isActive: (param) => !!param && param.length >= 3,
    valueTransform: value => value.toLowerCase(),
    resultFilter: (value, result) => {
        const terms = result.filterResults[AddOn_SearchTerms.key].value;
        let index;
        //Find exact match
        index = terms.findIndex(term => term === value);
        if (index !== -1)
            return { pass: true, score: calcScore(BaseScore.ExactMatch, index) };
        //Find StatsWith
        index = terms.findIndex(term => term.startsWith(value));
        if (index !== -1)
            return { pass: true, score: calcScore(BaseScore.StartsWith, index) };
        //Find Includes
        index = terms.findIndex(term => term.includes(value));
        if (index !== -1)
            return { pass: true, score: calcScore(BaseScore.Includes, index) };
        return { pass: false };
    }
};
//# sourceMappingURL=types.js.map